import u from "../bundled_deps/.pnpm/@intercom_intermoji@2.0.0/bundled_deps/@intercom/intermoji/lib/intermoji.js";
var i = /* @__PURE__ */ ((t) => (t[t.None = -1] = "None", t[t.Light = 127995] = "Light", t[t.MediumLight = 127996] = "MediumLight", t[t.Medium = 127997] = "Medium", t[t.MediumDark = 127998] = "MediumDark", t[t.Dark = 127999] = "Dark", t))(i || {});
function p(t) {
  return u.splitOnUnicodeEmojis(t).reduce(function(e, o) {
    return e += u.isSupportedUnicode(o) ? a(u.identifierFromUnicode(o)) : o;
  }, "");
}
function c(t) {
  return u.substituteUnicodeForColonified(t);
}
let r;
function m() {
  return r === void 0 && (r = u.hasNativeSupport(document)), r;
}
function a(t) {
  return `:${t}:`;
}
function d() {
  r = !1;
}
function l() {
  r = !0;
}
export {
  i as SkinToneModifiers,
  d as disableNativeEmojiSupport,
  l as enableNativeEmojiSupport,
  m as hasNativeEmojiSupport,
  p as substituteColonifiedForUnicode,
  c as substituteUnicodeForColonified
};
